module.exports = __webpack_public_path__ + "static/img/banner4.9f26a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner4.png
// module id = GM7j
// module chunks = 1